import { render } from "./AiSemulajadi.vue?vue&type=template&id=f7558a5e"
import script from "./AiSemulajadi.vue?vue&type=script&lang=js"
export * from "./AiSemulajadi.vue?vue&type=script&lang=js"

import "./AiSemulajadi.vue?vue&type=style&index=0&id=f7558a5e&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__